import React from 'react';
import { View } from 'react-native';
import MdIcon from 'react-native-vector-icons/MaterialIcons';
import type { LanguageSelectorProps } from '../LanguageSelector';
import styles from './styles';
import LanguageButtons from '../LanguageButtons';

interface LanguageSelectPopupProps {
    languages: LanguageSelectorProps['languages'];
    currentLanguage: LanguageSelectorProps['currentLanguage'];
    onSelect: LanguageSelectorProps['onSelect'];
}

const LanguageSelectPopup = ({
    languages,
    currentLanguage,
    onSelect
}: LanguageSelectPopupProps): JSX.Element => (
    <View style={styles.languagesPopup}>
        <MdIcon style={styles.popupTriangle} size={32} name="arrow-drop-up" color="white" />
        <LanguageButtons
            languages={languages}
            currentLanguage={currentLanguage}
            onSelect={onSelect}
        />
    </View>
);

export default LanguageSelectPopup;
